module.exports = __webpack_public_path__ + "static/img/scrollImg1.1f2d0a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scrollImg1.png
// module id = aN2a
// module chunks = 2